import useSWR from 'swr'

import { ENDPOINTS } from '../service/ENDPOINTS'
import { getReq } from '../service/API'

export const SUBJECT_JOURNEY = 'SUBJECT_JOURNEY'
export const NEEDS_DATA_SYNC = 'NEEDS_DATA_SYNC'
export const DATA_SYNCED = 'DATA_SYNCED'
export const ELIGIBILITY_ERROR = 'ELIGIBILITY_ERROR'

export const NO_ELIGIBILITY = 'NO_ELIGIBILITY'
export const SUBJECT_IS_TERMINATED = 'SUBJECT_IS_TERMINATED'
export const COMPLETE_STUDY = 'COMPLETE_STUDY'

export const COMPLETED = 'COMPLETED'

//

export const usePhaseConfigEvaluator = (projectId, subjectId) => {
  const p = ENDPOINTS.SUBJECTS.configEvaluator(projectId, subjectId)

  const { data, error, mutate } = useSWR(p, getReq, { suspense: false })

  return {
    data: !data ? data : data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
